import React, { useEffect, useState } from "react";
import Mapir from "mapir-react-component";
import { getDeliverLocaApi } from "../../Api/ClientServices";
import Style from './LiveLocationMap.module.css'
import { errorToast } from "../../Toast/Toast";
const Map = Mapir.setToken({
  transformRequest: (url) => {
    return {
      url: url,
      headers: {
        "x-api-key":"eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImE1ODNiNzIzMWNjNTcxNzg4OGI2NzZkODI1NjNjM2RjNGQyNDJlMGVlZmQ3ZDcyZmYxYTZmN2E5ZDhjNmI3YTNhOWIxOTE1ZTdkOTQ5MDE1In0.eyJhdWQiOiIxNTE2OCIsImp0aSI6ImE1ODNiNzIzMWNjNTcxNzg4OGI2NzZkODI1NjNjM2RjNGQyNDJlMGVlZmQ3ZDcyZmYxYTZmN2E5ZDhjNmI3YTNhOWIxOTE1ZTdkOTQ5MDE1IiwiaWF0IjoxNjg3NjA2MzI2LCJuYmYiOjE2ODc2MDYzMjYsImV4cCI6MTY4OTA3NTEyNiwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.oSSkLtV_ZrBPiOLVVRjgAdbmtIKaA03H4zigvRXvnePLmkPd1oBQA4M4k4a68-JB3HtQmcOiXGSB0g_btjL6eArzq6f5g6tjAi0Hr7UV_AyCZXNDEcD1-ZnswznydpHsAiVNtmHD81PloLw6OV_WfQLqZXkE__jVttwk6Pi_8i7G6xEuenJ5GQxxwsyIBxdGvdXu-S85M0ULxcCWaaq1q-fKL9LfqyzxUz-whl_4SgqQHbxrypvuZ3Gi8zv9TYVy0GQx55Rw0rGXnxouQc-xAuWZFMJZ8xMxTPj-Nj4EYoanBvl4oKAqHANbMi-hZq9G-MBlI6bfLE05uN37XAInCA",
        "Mapir-SDK": "reactjs",
      },
    };
  },
  dragRotate:false,
});
export default function LiveLocationMap(props) {
  const [center, setCenter] = useState([36.431987, 52.386548]);
  const [markerArray, setMarkerArray] = useState([]);

  const MINUTE_MS = 6000;
  useEffect(() => {
    const interval = setInterval(() => {
      getLocation();
    }, MINUTE_MS);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getLocation = async () => {
    getDeliverLocaApi(props.orderId,(succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          mapClickHandler(res);
        }
      }else{
        console.error(res)
      }
    })
  };
  function mapClickHandler(e) {
    setCenter([e.location.lon, e.location.lat]);
    // setZoom(9)
    localStorage.setItem("checkMarker", true);
    reverseFunction(e);
  }

  function reverseFunction(e) {
    // var url = `https://map.ir/reverse/no?lon=${e.location.lon}&lat=${e.location.lat}`;
    var url = `https://map.ir/routes/match/v1/driving/${e.location.lon},${e.location.lat}`;
    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        "x-api-key":
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijg3MzUwNWY0NmMwM2I1M2NiYzU1ZDdhNzIwN2Y4OWM0NDJlYzNhNzEzYTM3YmUxZDg3YmZhN2UzODI5YWNkYzIyMGYyYWQ3ZmU3ZDBlZWY0In0.eyJhdWQiOiIxNTE2OCIsImp0aSI6Ijg3MzUwNWY0NmMwM2I1M2NiYzU1ZDdhNzIwN2Y4OWM0NDJlYzNhNzEzYTM3YmUxZDg3YmZhN2UzODI5YWNkYzIyMGYyYWQ3ZmU3ZDBlZWY0IiwiaWF0IjoxNjQ5NjY5MTQ5LCJuYmYiOjE2NDk2NjkxNDksImV4cCI6MTY1MDcwNTk0OSwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.QtGGJZjSmZZYG_sss24KJ8XjqiWorsya-emnAMHMX2iaKZEK9Uw_IMmRU3EZFqpSo0r-ueXxFs4EcT9WJobwyMafHnHjTC9yBcICHjh-imGWqjuyE5Xr487-ZAAWuQ1GvT4gTRxFdfMUFDe0wsjY8eNmqYPkcfslJnsyWgUO_GcZsg_xnWpyRdJbPaWWDEr9if1SpjGGEXSmQjWU-psCCwy2wIB4CL1xLvMrT3mHBqx2mp7RrO82gOVD9obnZYGjIXDBa9v1CCqnbjhkqOVDW4_kcnC8UNdHsNvdnRXhJEV3eIhdmEJzIX9IG1DwfC3cpm_a8xm_NzQK-g27lWfHJQ",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // localStorage.setItem('lon',data.geom.coordinates[1])
        // localStorage.setItem('lat',data.geom.coordinates[0])
        //   localStorage.setItem('address_compact',data.address_compact)
      });
    const array = [];
    array.push(
      <Mapir.Marker
        className={Style.inMarker}
        coordinates={[e.location.lon, e.location.lat]}
        // degree={`rotate(${parseInt(e.location.bearing)}deg)`}
        key={0}
      />
      );
      setMarkerArray(array);
  }
  return (
    <>
      <div>
        <Mapir center={center} zoom={[13]} Map={Map}>
          
    <div className={Style.marker}>
            {markerArray}
    </div>
          
        </Mapir>
      </div>
    </>
  );
}
